import { render, staticRenderFns } from "./HeroOne.vue?vue&type=template&id=3a022c08&scoped=true"
import script from "./HeroOne.vue?vue&type=script&lang=js"
export * from "./HeroOne.vue?vue&type=script&lang=js"
import style0 from "./HeroOne.vue?vue&type=style&index=0&id=3a022c08&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3a022c08",
  null
  
)

export default component.exports